module.exports = __webpack_public_path__ + "img/svg/result-loser-button-background.e65d41a76b98467515069a0422ccd785.svg";